import { useState } from 'react';
import { Container, Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { keyframes } from '@emotion/react';
import { ConnectionFailed } from './ConnectionFailed/ConnectionFailed';
import { ConnectionModal } from './ConnectionModal/ConnectionModal';
import { ConnectionSuccess } from './ConnectionSuccess/ConnectionSuccess';
import { Loading } from '../../../icons/Loading';
import { useAppStateContext } from '../../AppStateProvider/AppStateProvider';

const loadingAnimation = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const ConnectivityContainer = styled(Grid)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

const TextBox = styled(Typography)({
  width: '340px',
  height: '48px',
  textAlign: 'center',
});

const LoadingWrapper = styled('div')({
  animation: `${loadingAnimation} 1.5s linear infinite`,
  display: 'flex',
});

export function Connectivity() {
  const { state } = useAppStateContext();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const signalingGateway = state.preflightTest.signalingGatewayReachable ? 'Reachable' : 'Unreachable';
  const turnServers = state.preflightTest.turnServersReachable ? 'Reachable' : 'Unreachable';

  const connectionFailed =
    state.preflightTestFinished &&
    (state.preflightTest.error !== null ||
      !state.preflightTest.signalingGatewayReachable ||
      !state.preflightTest.turnServersReachable);

  return (
    <>
      <ConnectionModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        serviceStatuses={state.twilioStatus}
        signalingGateway={signalingGateway}
        turnServers={turnServers}
      />
      {
        /* If preflight test or bitrate test haven't completed, display loading screen otherwise, display connectivity results: */
        state.preflightTestInProgress || state.bitrateTestInProgress ? (
          <Container>
            <ConnectivityContainer container>
              <Typography variant="h1" gutterBottom>
                Hang tight!
              </Typography>
              <TextBox variant="body1" gutterBottom>
                We're just finishing up your personalized results and creating your report.
              </TextBox>
              <LoadingWrapper>
                <Loading />
              </LoadingWrapper>
            </ConnectivityContainer>
          </Container>
        ) : connectionFailed ? (
          <ConnectionFailed openModal={() => setIsModalOpen(true)} />
        ) : (
          <ConnectionSuccess openModal={() => setIsModalOpen(true)} />
        )
      }
    </>
  );
}
